import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Login } from "./pages/login";
import { Resetpassword, Resetpasswordsuccess } from "./pages/resetpassword";
import { Layout } from "./layouts/layout";
import { EmpPermission, EmpManagePermission, Permission } from "pages/employee/permission";
import { Emp, EmpCreate } from "pages/employee/emp";
import { Distributor, DistributorGroup } from "pages/distributor/distributor";
import { DistributorCreate } from "pages/distributor/distributorCreate";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import GlobalLoader from "layouts/GlobalLoader";
import { Routes, Route } from "react-router-dom";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import GlobalModal from "layouts/GlobalModal";
import ProtectedRoutes from "router/protected.routes";
import PublicRoutes from "router/public.routes";
import { VER, domain } from "constants/server/api";
import NotFoundPage from "pages/NotFoundPage";
import { PRList } from "pages/purchase/requisitionDatalist";
import { PRCreate } from "pages/purchase/requisition";
import { POList } from "pages/purchase/orderDatalist";
import { POCreate } from "pages/purchase/Order";
import { GRList } from "pages/goodsreceipt/GoodsReceiptDatalist";
import { GoodsReceipt } from "pages/goodsreceipt/GoodsReceipt";
import { CreditorList } from "pages/financial/creditors/datalist";
import { CheckGoodsReceipt } from "pages/financial/creditors/GoodsReceipt";
import { env } from "env";
import { ReportBuySupplier } from "pages/report/buy/supplier";
import { ReportBuyOrder } from "pages/report/buy/order";
import { ReportBuyPoItem } from "pages/report/buy/poItem";
import { ReportBuyGrItem } from "pages/report/buy/grItem";
import { ExpenseList } from "pages/financial/expense/datalist";
import { ExpenseCreate } from "pages/financial/expense/expense";
import { ReportGrItemExpense } from "pages/report/buy/grItemWithExpense";
import { QuotationList } from "pages/sale/QuotationDatalist";
import { QuotationCreate } from "pages/sale/Quotation";
import { SaleOrderList } from "pages/sale/SaleOrderDatalist";
import { SaleOrderCreate } from "pages/sale/SaleOrder";
import GlobalModalNotiDoc from "layouts/GlobalModalNotiDoc";
import { companyinfoTestData } from "mocks/printCompanyInfoData";
import { DeliveryOrderCreate } from "pages/sale/DeliveryOrderCreate";
import { DeliveryOrderDatalist } from "pages/sale/DeliveryOrderDatalist";
import { InvoiceDatalist } from "pages/sale/InvoiceDatalist";
import { InvoiceCreate } from "pages/sale/InvoiceCreate";
import { ReceiptDatalist } from "pages/sale/ReceiptDatalist";
import { ReceiptCreate } from "pages/sale/ReceiptCreate";
import { PrintReceipt } from "layouts/PrintReceipt";
import { printReceiptTestData } from "mocks/printReceiptData";
import ReportProductDo from "pages/report/sale/reportProductDoPage/ReportProductDo";
import { PrintInvoice } from "layouts/PrintInvoice";
import { printInvoiceTestData } from "mocks/printInvoiceData";
import { PesDatalist } from "pages/financial/peak/PesDatalist";
import { PesCreate } from "pages/financial/peak/PesCreate";
function App() {
    var _useState = _sliced_to_array(useState(1), 2), selectbranchID = _useState[0], setSelectBranchID = _useState[1];
    var isLoading = useGlobalLoaderContext().isLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    useEffect(function() {
        console.log("env", env.REACT_APP_ENV);
        console.log("domain-api", domain);
        console.log("version-check", VER);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isLoading && /*#__PURE__*/ _jsx(GlobalLoader, {}),
            /*#__PURE__*/ _jsx(GlobalModal, {
                show: modalObj.visible,
                title: modalObj.title,
                subTitle: modalObj.subTitle,
                btnText: modalObj.btnText,
                onHide: function() {
                    return setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                        visible: false
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(GlobalModalNotiDoc, {}),
            /*#__PURE__*/ _jsxs(Routes, {
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password",
                        element: /*#__PURE__*/ _jsx(Resetpassword, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/reset/password/success",
                        element: /*#__PURE__*/ _jsx(Resetpasswordsuccess, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(PublicRoutes, {}),
                        children: /*#__PURE__*/ _jsx(Route, {
                            path: "/login",
                            element: /*#__PURE__*/ _jsx(Login, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(ProtectedRoutes, {}),
                        children: /*#__PURE__*/ _jsxs(Route, {
                            path: "/",
                            element: /*#__PURE__*/ _jsx(Layout, {
                                setSelectBranchID: setSelectBranchID,
                                selectbranchID: selectbranchID
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps",
                                    element: /*#__PURE__*/ _jsx(Emp, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/create",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emps/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission",
                                    element: /*#__PURE__*/ _jsx(EmpPermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/create",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/emp/permission/edit/:empID",
                                    element: /*#__PURE__*/ _jsx(EmpManagePermission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/permission",
                                    element: /*#__PURE__*/ _jsx(Permission, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor",
                                    element: /*#__PURE__*/ _jsx(Distributor, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributorgroup",
                                    element: /*#__PURE__*/ _jsx(DistributorGroup, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/create",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/distributor/edit/:supID",
                                    element: /*#__PURE__*/ _jsx(DistributorCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition",
                                    element: /*#__PURE__*/ _jsx(PRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/create",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/requisition/edit/:prID",
                                    element: /*#__PURE__*/ _jsx(PRCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/orders",
                                    element: /*#__PURE__*/ _jsx(POList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/create",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/purchase/order/edit/:poID",
                                    element: /*#__PURE__*/ _jsx(POCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/quotation",
                                    element: /*#__PURE__*/ _jsx(QuotationList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/quotation/create",
                                    element: /*#__PURE__*/ _jsx(QuotationCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/quotation/edit/:qoID",
                                    element: /*#__PURE__*/ _jsx(QuotationCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/sale-order",
                                    element: /*#__PURE__*/ _jsx(SaleOrderList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/sale-order/create",
                                    element: /*#__PURE__*/ _jsx(SaleOrderCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/sale-order/edit/:soID",
                                    element: /*#__PURE__*/ _jsx(SaleOrderCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/delivery-order",
                                    element: /*#__PURE__*/ _jsx(DeliveryOrderDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/delivery-order/create",
                                    element: /*#__PURE__*/ _jsx(DeliveryOrderCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/delivery-order/create/:soID",
                                    element: /*#__PURE__*/ _jsx(DeliveryOrderCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/delivery-order/edit/:doID",
                                    element: /*#__PURE__*/ _jsx(DeliveryOrderCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/invoice",
                                    element: /*#__PURE__*/ _jsx(InvoiceDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/invoice/create",
                                    element: /*#__PURE__*/ _jsx(InvoiceCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/invoice/create/:doID",
                                    element: /*#__PURE__*/ _jsx(InvoiceCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/invoice/edit/:invoiceID",
                                    element: /*#__PURE__*/ _jsx(InvoiceCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/receipt",
                                    element: /*#__PURE__*/ _jsx(ReceiptDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/receipt/create",
                                    element: /*#__PURE__*/ _jsx(ReceiptCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/receipt/create/:invoiceID",
                                    element: /*#__PURE__*/ _jsx(ReceiptCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/sale/receipt/edit/:receiptID",
                                    element: /*#__PURE__*/ _jsx(ReceiptCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt",
                                    element: /*#__PURE__*/ _jsx(GRList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/goods-receipt/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(GoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor",
                                    element: /*#__PURE__*/ _jsx(CreditorList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/creditor/goods-receipt/:dataID",
                                    element: /*#__PURE__*/ _jsx(CheckGoodsReceipt, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expenses",
                                    element: /*#__PURE__*/ _jsx(ExpenseList, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/expense/:action/:dataID",
                                    element: /*#__PURE__*/ _jsx(ExpenseCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/peak-connection/pes",
                                    element: /*#__PURE__*/ _jsx(PesDatalist, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/peak-connection/pes/create",
                                    element: /*#__PURE__*/ _jsx(PesCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/financial-accounting/peak-connection/pes/edit/:pesID",
                                    element: /*#__PURE__*/ _jsx(PesCreate, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/supplier",
                                    element: /*#__PURE__*/ _jsx(ReportBuySupplier, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/order",
                                    element: /*#__PURE__*/ _jsx(ReportBuyOrder, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/po-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyPoItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/buy/gr-item",
                                    element: /*#__PURE__*/ _jsx(ReportBuyGrItem, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/financial/gr-item-expense",
                                    element: /*#__PURE__*/ _jsx(ReportGrItemExpense, {})
                                }),
                                /*#__PURE__*/ _jsx(Route, {
                                    path: "/report/sale/product-do",
                                    element: /*#__PURE__*/ _jsx(ReportProductDo, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "*",
                        element: /*#__PURE__*/ _jsx(NotFoundPage, {})
                    })
                ]
            })
        ]
    });
}
function Home() {
    return /*#__PURE__*/ _jsx("div", {});
}
function Layoutadmin() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "page",
        children: [
            /*#__PURE__*/ _jsx(Layout, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "main-content app-content"
            })
        ]
    });
}
export default App;
